import { displayMode_FreeText, displayMode_Search, } from '@app/advisor-shared';
import { ModuleFE_Advisor_Action, ModuleFE_Advisor_AdvisorSnippet, ModuleFE_RuntimeOrder, translateWizardData } from '@app/advisor-frontend';
import { exists, MUSTNeverHappenException, scrub } from '@nu-art/ts-common';
export const prepareSubmissionData = (wizard, wizardData, stepIndex) => {
    const data = {};
    const stepData = wizardData.stepData[stepIndex];
    if (stepData.displayMode === displayMode_FreeText) {
        //Insert free text to the data object for each snippet id
        stepData.snippets[displayMode_FreeText].forEach(snippet => {
            const freeTextData = wizardData.freeTextData[snippet.snippetId];
            if (!freeTextData)
                return;
            data[snippet.snippetId] = { text: freeTextData.text, resolvingVariableId: freeTextData.resolvedVariableId };
        });
    }
    else {
        const usedVarIds = [];
        //Insert variable data to the data object for each snippet id
        stepData.snippets[displayMode_Search].forEach(snippet => {
            const dbSnippet = ModuleFE_Advisor_AdvisorSnippet.cache.unique(snippet.snippetId);
            if (!dbSnippet)
                throw new MUSTNeverHappenException(`Could not find snippet for id ${snippet.snippetId}`);
            data[snippet.snippetId] = {};
            dbSnippet.formVariables?.forEach(formVar => {
                const varDatas = wizardData.variableData[formVar.id];
                if (!varDatas)
                    return;
                const dataToAdd = [];
                varDatas.forEach(varData => {
                    if (exists(varData.isChiefComplaint) && (varData.isChiefComplaint !== dbSnippet.config.produceChiefComplaint))
                        return;
                    if (usedVarIds.includes(formVar.id))
                        return;
                    if (exists(varData.valueId)) {
                        dataToAdd.push({
                            valueId: varData.valueId,
                            existingFindingId: varData.existingFindingId,
                            isChiefComplaint: varData.isChiefComplaint,
                            snippetId: snippet.snippetId,
                            attributes: varData.attributes ?? {},
                        });
                        usedVarIds.push(formVar.id);
                    }
                    if (exists(varData.rawValue)) {
                        dataToAdd.push({
                            rawValue: varData.rawValue,
                            existingFindingId: varData.existingFindingId,
                            isChiefComplaint: varData.isChiefComplaint,
                            snippetId: snippet.snippetId,
                            attributes: varData.attributes ?? {},
                        });
                    }
                });
                if (dataToAdd.length)
                    data[snippet.snippetId][formVar.id] = dataToAdd;
            });
        });
    }
    //Add variable id to request for navigator to satisfy pre-conditions
    const runtimeOrderId = wizardData.contextType === 'order' ? wizardData.contextId : undefined;
    let dbOrder;
    if (runtimeOrderId) {
        const rtOrder = ModuleFE_RuntimeOrder.cache.unique(runtimeOrderId);
        if (!rtOrder)
            throw new MUSTNeverHappenException(`Could not get rtOrder for id ${runtimeOrderId}`);
        dbOrder = ModuleFE_Advisor_Action.cache.unique(rtOrder.orderId);
        if (!dbOrder)
            throw new MUSTNeverHappenException(`Could not get order for id ${rtOrder.orderId}`);
    }
    const cleanData = scrub(data, { emptyArrays: true, emptyObjects: true, returnCopy: false }) ?? {};
    return {
        wizardId: wizard._id,
        fulfilled: stepIndex === wizard.steps.length - 1,
        runtimeOrderId: wizardData.contextType === 'order' ? wizardData.contextId : undefined,
        ...translateWizardData(cleanData, wizard._id, dbOrder?.variableId),
    };
};
//# sourceMappingURL=prepare-submission-data.js.map